var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebartoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#21132C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#5C5661"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1969 8C17.8248 8 17.5255 8.13913 17.2667 8.41739L11.1763 14.8C10.8285 15.1739 10.6749 15.5391 10.6668 16C10.6668 16.4522 10.8285 16.8348 11.1763 17.2L17.2586 23.5913C17.5255 23.8609 17.8329 24 18.1969 24C18.941 24 19.5557 23.3565 19.5557 22.5565C19.5557 22.1565 19.3939 21.7913 19.1189 21.487L13.8373 15.9913L19.1189 10.513C19.402 10.2087 19.5557 9.84348 19.5557 9.44348C19.5557 8.65217 18.941 8 18.1969 8Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebartoogle);
export default __webpack_public_path__ + "static/media/Sidebartoogle.3686e0559b6b9c93884db401635faee4.svg";
export { ForwardRef as ReactComponent };